import { Link } from "wouter";
import { INDEX_SYMBOL, fmtSol, fmtTime, shortMint } from "../lib/data";
import LotteryCountdown from "./LotteryCountdown";

export default function LotterySection({ data }) {
  const lottery = data?.lottery;
  const schedule = data?.schedule || {};
  const pct = lottery?.lotteryPct ?? schedule.lotteryPct ?? 10;
  const last = lottery?.lastWinner;
  const pot = lottery?.potSol;

  return (
    <section className="app-section lottery-section">
      <div className="shell">
        <div className="section-intro">
          <p className="section-kicker">
            <i className="brand-diamond" aria-hidden /> Lottery
          </p>
          <h2 className="section-title">Equal-odds SOL pot</h2>
          <p className="section-lead left">
            {`~${pct}% of each fee cycle accrues to a pot. Draws fire on a random ${lottery?.intervalMin ?? 20}–${lottery?.intervalMax ?? 60}m clock. Every wallet with ≥${(schedule.minHolderTokens ?? 10000).toLocaleString()} $${INDEX_SYMBOL} gets one ticket — same odds, any size.`}
          </p>
        </div>

        <div className="lottery-rail">
          <div className="metric">
            <div className="label">Pot</div>
            <strong>{pot != null ? `${fmtSol(pot)} SOL` : "—"}</strong>
            <p className="metric-note">~{pct}% of each cycle</p>
          </div>
          <div className="metric">
            <div className="label">Draws</div>
            <strong>{lottery?.drawCount ?? 0}</strong>
            <p className="metric-note">Archived winners</p>
          </div>
          <div className="metric">
            <div className="label">Last winner</div>
            <strong style={{ fontSize: "1.05rem" }}>
              {last?.address ? shortMint(last.address, 4) : "—"}
            </strong>
            <p className="metric-note">
              {last?.amountSol != null
                ? `${fmtSol(last.amountSol)} SOL · ${fmtTime(last.at)}`
                : "Waiting on first draw"}
            </p>
          </div>
          <LotteryCountdown lottery={lottery} />
        </div>

        <div className="section-actions section-actions--row">
          <Link href="/lottery" className="btn btn-lime">
            Past winners
          </Link>
          <Link href="/docs" className="btn btn-ghost">
            How it works
          </Link>
        </div>
      </div>
    </section>
  );
}
